// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --color-white-100: hsl(206, 5%, 100%);
  --color-white-200: hsl(206, 5%, 96%);
  --color-white-300: hsl(206, 5%, 80%);
  --color-white-400: hsl(206, 5%, 65%);
  --color-white-500: hsl(206, 5%, 50%);

  --color-black-100: hsl(213, 20%, 9%);
  --color-black-200: hsl(213, 23%, 8%);
  --color-black-300: hsl(214, 21%, 6%);
  --color-black-400: hsl(210, 21%, 6%);
  --color-black-500: hsl(216, 22%, 4%);

  --color-red-100: hsl(349, 100%, 90%);
  --color-red-200: hsl(349, 100%, 80%);
  --color-red-300: hsl(349, 100%, 70%);
  --color-red-400: hsl(349, 100%, 60%);
  --color-red-500: hsl(349, 100%, 45%);

  --color-primary: #F29E22;

  

  --shadow-small: 0 1px 3px 0 rgba(0, 0, 0, 0.1),
    0 1px 2px 0 rgba(0, 0, 0, 0.06);
  --shadow-medium: 0 4px 6px -1px rgba(0, 0, 0, 0.1),
    0 2px 4px -1px rgba(0, 0, 0, 0.06);
  --shadow-large: 0 10px 15px -3px rgba(0, 0, 0, 0.1),
    0 4px 6px -2px rgba(0, 0, 0, 0.05);
}

*,
*::before,
*::after {
  padding: 0;
  margin: 0;
  box-sizing: border-box;
  list-style: none;
  list-style-type: none;
  text-decoration: none;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-rendering: optimizeLegibility;
}

html {
  font-size: 100%;
  box-sizing: inherit;
  scroll-behavior: smooth;
  height: -webkit-fill-available;
}

body {
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: var(--color-black-500);
  background-color: var(--color-white-100);
}

main {
  overflow: hidden;
}

a,
button {
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  border: none;
  outline: none;
  background: none;
  box-shadow: none;
}

img,
video {
  display: block;
  max-width: 100%;
  height: auto;
  object-fit: cover;
}

/* Elements */
.section {
  margin: 0 auto;
  padding: 5rem 0 2rem;
}

.container {
  max-width: 80rem;
  height: auto;
  margin: 0 auto;
  padding: 0 1.25rem;
}

.centered {
  text-align: center;
  vertical-align: middle;
  margin-bottom: 1rem;
}

.btn {
  display: inline-block;
  font-family: inherit;
  font-size: 1rem;
  font-weight: 500;
  line-height: 1.5;
  text-align: center;
  vertical-align: middle;
  white-space: nowrap;
  -webkit-user-select: none;
          user-select: none;
  outline: none;
  border: none;
  border-radius: 0.25rem;
  text-transform: unset;
  transition: all 0.3s ease-in-out;
}

.btn-darken {
  padding: 0.75rem 2rem;
  color: var(--color-white-100);
  background-color: var(--color-black-200);
  box-shadow: var(--shadow-medium);
}

.btn-neutral {
  padding: 0.75rem 2rem;
  color: var(--color-black-500);
  background-color: var(--color-white-100);
  box-shadow: var(--shadow-medium);
}

/* Headers */
.header {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 100;
  width: 100%;
  height: auto;
  margin: 0 auto;
  /* background: var(--color-white-100); */
  background-color: #131921;
  box-shadow: var(--shadow-medium);
}

.navbar {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  align-items: center;
  align-content: center;
  height: auto;
  padding-top: 0.5rem;
}

/* Responsive Media Query */
@media only screen and (min-width: 62rem) {
  .navbar {
    grid-template-columns: repeat(3, minmax(0, 1fr));
    width: 100%;
    height: 4.25rem;
    padding-top: 0;
    margin: 0 auto;
  }
}

.brand {
  justify-self: start;
  font-family: inherit;
  font-size: 1.6rem;
  font-weight: 700;
  line-height: 1.25;
  letter-spacing: -1px;
  text-transform: uppercase;
  color: var(--color-red-500);
}

.search {
  grid-column: span 2;
  order: 3;
  width: 100%;
  height: auto;
  margin: 0 auto;
  padding-block: 1rem;
}

.search-form {
  display: flex;
  align-items: center;
  justify-content: space-between;
  max-width: 100%;
  width: 100%;
  height: auto;
  padding-inline: 1.5rem;
  border-radius: 10px;
  background: var(--color-white-200);
  position: relative; /* Add this */
}

.search-icon {
  position: absolute; /* Add this */
  margin-top: 0.2rem;
  /* Adjust the position as needed */
  font-size: 1.25rem;
  color: var(--color-black-400); /* Adjust the color as needed */
}

.search-input {
  display: block;
  font-family: inherit;
  font-size: 1rem;
  font-weight: normal;
  line-height: inherit;
  width: 100%;
  height: 100%;
  padding-block: 0.75rem;
  padding-left: 0.5rem; /* Add padding to the left to make room for the icon */
  border: none;
  outline: none;
  color: var(--color-black-500);
  background: transparent;
}

.search-submit {
  display: none; /* Hide the button as we're using the icon inside the input */
}

/* Responsive Media Query */
@media only screen and (min-width: 62rem) {
  .search {
    justify-self: center;
    grid-column: initial;
    order: initial;
    width: 100%;
    height: auto;
  }

  .search-form {
    max-width: 30rem;
  }
}

.menu {
  position: fixed;
  top: -100%;
  left: 0;
  width: 100%;
  height: auto;
  overflow: hidden;
  padding-block: 3rem 2rem;
  background: var(--color-white-100);
  box-shadow: var(--shadow-medium);
  transition: all 0.45s ease-in-out;
}

.menu.is-active {
  top: 0;
  width: 100%;
  height: inherit;
}

.menu-inner {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  row-gap: 1.25rem;
}

.menu-link {
  font-family: inherit;
  font-size: 1rem;
  font-weight: 500;
  line-height: inherit;
  text-transform: uppercase;
  /* color: var(--color-black-500); */
  color: white;
  transition: all 0.35s ease-in-out;
}

.menu-link:hover {
  outline: none;
  color: var(--color-primary);
}

/* Responsive Media Query */
@media only screen and (min-width: 36rem) {
  .menu {
    position: relative;
    justify-self: end;
    top: 0;
    left: inherit;
    width: auto;
    height: auto;
    padding-block: 0;
    background: none;
    box-shadow: none;
    transition: none;
  }

  .menu-inner {
    display: flex;
    flex-direction: row;
    column-gap: 1.25rem;
    margin: 0 auto;
  }

  .menu-link {
    text-transform: capitalize;
  }
}

.burger {
  position: relative;
  justify-self: end;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  z-index: 10;
  width: 1.6rem;
  height: 1.15rem;
  border: none;
  outline: none;
  background: none;
  visibility: visible;
  transform: rotate(0deg);
  transition: 0.35s ease;
}

/* Responsive Media Query */
@media only screen and (min-width: 36rem) {
  .burger {
    display: none;
    visibility: hidden;
  }
}

.burger-line {
  position: absolute;
  width: 100%;
  height: 2px;
  border-radius: 1rem;
  background: var(--color-black-500);
  transition: all 0.35s ease;
}

.burger-line:nth-child(1) {
  top: 0;
}

.burger-line:nth-child(2) {
  top: 0.55rem;
}

.burger-line:nth-child(3) {
  top: 1.1rem;
}

.burger.is-active .burger-line:nth-child(1) {
  top: 0.55rem;
  transform: rotate(135deg);
}

.burger.is-active .burger-line:nth-child(2) {
  opacity: 0;
  visibility: hidden;
}

.burger.is-active .burger-line:nth-child(3) {
  top: 0.55rem;
  transform: rotate(-135deg);
}

/* Scrollbar */
::-webkit-scrollbar {
  width: 0.5rem;
}

::-webkit-scrollbar-thumb {
  background: var(--color-black-400);
  border-radius: 0.25rem;
}

::-webkit-scrollbar-thumb:hover {
  background: var(--color-black-200);
}

::-webkit-scrollbar-track {
  background: var(--color-white-300);
}
`, "",{"version":3,"sources":["webpack://./src/style/Header.css"],"names":[],"mappings":"AAAA;EACE,qCAAqC;EACrC,oCAAoC;EACpC,oCAAoC;EACpC,oCAAoC;EACpC,oCAAoC;;EAEpC,oCAAoC;EACpC,oCAAoC;EACpC,oCAAoC;EACpC,oCAAoC;EACpC,oCAAoC;;EAEpC,oCAAoC;EACpC,oCAAoC;EACpC,oCAAoC;EACpC,oCAAoC;EACpC,oCAAoC;;EAEpC,wBAAwB;;;;EAIxB;mCACiC;EACjC;sCACoC;EACpC;sCACoC;AACtC;;AAEA;;;EAGE,UAAU;EACV,SAAS;EACT,sBAAsB;EACtB,gBAAgB;EAChB,qBAAqB;EACrB,qBAAqB;EACrB,mCAAmC;EACnC,kCAAkC;EAClC,kCAAkC;AACpC;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,uBAAuB;EACvB,8BAA8B;AAChC;;AAEA;EACE,4DAA4D;EAC5D,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,6BAA6B;EAC7B,wCAAwC;AAC1C;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;EACjB,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;;EAEE,cAAc;EACd,eAAe;EACf,YAAY;EACZ,iBAAiB;AACnB;;AAEA,aAAa;AACb;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB,mBAAmB;EACnB,yBAAiB;UAAjB,iBAAiB;EACjB,aAAa;EACb,YAAY;EACZ,sBAAsB;EACtB,qBAAqB;EACrB,gCAAgC;AAClC;;AAEA;EACE,qBAAqB;EACrB,6BAA6B;EAC7B,wCAAwC;EACxC,gCAAgC;AAClC;;AAEA;EACE,qBAAqB;EACrB,6BAA6B;EAC7B,wCAAwC;EACxC,gCAAgC;AAClC;;AAEA,YAAY;AACZ;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,cAAc;EACd,wCAAwC;EACxC,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,mBAAmB;EACnB,qBAAqB;EACrB,YAAY;EACZ,mBAAmB;AACrB;;AAEA,2BAA2B;AAC3B;EACE;IACE,gDAAgD;IAChD,WAAW;IACX,eAAe;IACf,cAAc;IACd,cAAc;EAChB;AACF;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;EACpB,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,mBAAmB;EACnB,kCAAkC;EAClC,kBAAkB,EAAE,aAAa;AACnC;;AAEA;EACE,kBAAkB,EAAE,aAAa;EACjC,kBAAkB;EAClB,kCAAkC;EAClC,kBAAkB;EAClB,6BAA6B,EAAE,+BAA+B;AAChE;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,eAAe;EACf,mBAAmB;EACnB,oBAAoB;EACpB,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,oBAAoB,EAAE,sDAAsD;EAC5E,YAAY;EACZ,aAAa;EACb,6BAA6B;EAC7B,uBAAuB;AACzB;;AAEA;EACE,aAAa,EAAE,6DAA6D;AAC9E;;AAEA,2BAA2B;AAC3B;EACE;IACE,oBAAoB;IACpB,oBAAoB;IACpB,cAAc;IACd,WAAW;IACX,YAAY;EACd;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE,eAAe;EACf,UAAU;EACV,OAAO;EACP,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,wBAAwB;EACxB,kCAAkC;EAClC,gCAAgC;EAChC,iCAAiC;AACnC;;AAEA;EACE,MAAM;EACN,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,yBAAyB;EACzB,mCAAmC;EACnC,YAAY;EACZ,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,2BAA2B;AAC7B;;AAEA,2BAA2B;AAC3B;EACE;IACE,kBAAkB;IAClB,iBAAiB;IACjB,MAAM;IACN,aAAa;IACb,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,cAAc;EAChB;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;EACjB,WAAW;EACX,aAAa;EACb,eAAe;EACf,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA,2BAA2B;AAC3B;EACE;IACE,aAAa;IACb,kBAAkB;EACpB;AACF;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,mBAAmB;EACnB,kCAAkC;EAClC,0BAA0B;AAC5B;;AAEA;EACE,MAAM;AACR;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,0BAA0B;AAC5B;;AAEA,cAAc;AACd;EACE,aAAa;AACf;;AAEA;EACE,kCAAkC;EAClC,sBAAsB;AACxB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;AACpC","sourcesContent":[":root {\n  --color-white-100: hsl(206, 5%, 100%);\n  --color-white-200: hsl(206, 5%, 96%);\n  --color-white-300: hsl(206, 5%, 80%);\n  --color-white-400: hsl(206, 5%, 65%);\n  --color-white-500: hsl(206, 5%, 50%);\n\n  --color-black-100: hsl(213, 20%, 9%);\n  --color-black-200: hsl(213, 23%, 8%);\n  --color-black-300: hsl(214, 21%, 6%);\n  --color-black-400: hsl(210, 21%, 6%);\n  --color-black-500: hsl(216, 22%, 4%);\n\n  --color-red-100: hsl(349, 100%, 90%);\n  --color-red-200: hsl(349, 100%, 80%);\n  --color-red-300: hsl(349, 100%, 70%);\n  --color-red-400: hsl(349, 100%, 60%);\n  --color-red-500: hsl(349, 100%, 45%);\n\n  --color-primary: #F29E22;\n\n  \n\n  --shadow-small: 0 1px 3px 0 rgba(0, 0, 0, 0.1),\n    0 1px 2px 0 rgba(0, 0, 0, 0.06);\n  --shadow-medium: 0 4px 6px -1px rgba(0, 0, 0, 0.1),\n    0 2px 4px -1px rgba(0, 0, 0, 0.06);\n  --shadow-large: 0 10px 15px -3px rgba(0, 0, 0, 0.1),\n    0 4px 6px -2px rgba(0, 0, 0, 0.05);\n}\n\n*,\n*::before,\n*::after {\n  padding: 0;\n  margin: 0;\n  box-sizing: border-box;\n  list-style: none;\n  list-style-type: none;\n  text-decoration: none;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  text-rendering: optimizeLegibility;\n}\n\nhtml {\n  font-size: 100%;\n  box-sizing: inherit;\n  scroll-behavior: smooth;\n  height: -webkit-fill-available;\n}\n\nbody {\n  font-family: \"Segoe UI\", Tahoma, Geneva, Verdana, sans-serif;\n  font-size: 1rem;\n  font-weight: 400;\n  line-height: 1.5;\n  color: var(--color-black-500);\n  background-color: var(--color-white-100);\n}\n\nmain {\n  overflow: hidden;\n}\n\na,\nbutton {\n  cursor: pointer;\n  user-select: none;\n  border: none;\n  outline: none;\n  background: none;\n  box-shadow: none;\n}\n\nimg,\nvideo {\n  display: block;\n  max-width: 100%;\n  height: auto;\n  object-fit: cover;\n}\n\n/* Elements */\n.section {\n  margin: 0 auto;\n  padding: 5rem 0 2rem;\n}\n\n.container {\n  max-width: 80rem;\n  height: auto;\n  margin: 0 auto;\n  padding: 0 1.25rem;\n}\n\n.centered {\n  text-align: center;\n  vertical-align: middle;\n  margin-bottom: 1rem;\n}\n\n.btn {\n  display: inline-block;\n  font-family: inherit;\n  font-size: 1rem;\n  font-weight: 500;\n  line-height: 1.5;\n  text-align: center;\n  vertical-align: middle;\n  white-space: nowrap;\n  user-select: none;\n  outline: none;\n  border: none;\n  border-radius: 0.25rem;\n  text-transform: unset;\n  transition: all 0.3s ease-in-out;\n}\n\n.btn-darken {\n  padding: 0.75rem 2rem;\n  color: var(--color-white-100);\n  background-color: var(--color-black-200);\n  box-shadow: var(--shadow-medium);\n}\n\n.btn-neutral {\n  padding: 0.75rem 2rem;\n  color: var(--color-black-500);\n  background-color: var(--color-white-100);\n  box-shadow: var(--shadow-medium);\n}\n\n/* Headers */\n.header {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 100;\n  width: 100%;\n  height: auto;\n  margin: 0 auto;\n  /* background: var(--color-white-100); */\n  background-color: #131921;\n  box-shadow: var(--shadow-medium);\n}\n\n.navbar {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  align-items: center;\n  align-content: center;\n  height: auto;\n  padding-top: 0.5rem;\n}\n\n/* Responsive Media Query */\n@media only screen and (min-width: 62rem) {\n  .navbar {\n    grid-template-columns: repeat(3, minmax(0, 1fr));\n    width: 100%;\n    height: 4.25rem;\n    padding-top: 0;\n    margin: 0 auto;\n  }\n}\n\n.brand {\n  justify-self: start;\n  font-family: inherit;\n  font-size: 1.6rem;\n  font-weight: 700;\n  line-height: 1.25;\n  letter-spacing: -1px;\n  text-transform: uppercase;\n  color: var(--color-red-500);\n}\n\n.search {\n  grid-column: span 2;\n  order: 3;\n  width: 100%;\n  height: auto;\n  margin: 0 auto;\n  padding-block: 1rem;\n}\n\n.search-form {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  max-width: 100%;\n  width: 100%;\n  height: auto;\n  padding-inline: 1.5rem;\n  border-radius: 10px;\n  background: var(--color-white-200);\n  position: relative; /* Add this */\n}\n\n.search-icon {\n  position: absolute; /* Add this */\n  margin-top: 0.2rem;\n  /* Adjust the position as needed */\n  font-size: 1.25rem;\n  color: var(--color-black-400); /* Adjust the color as needed */\n}\n\n.search-input {\n  display: block;\n  font-family: inherit;\n  font-size: 1rem;\n  font-weight: normal;\n  line-height: inherit;\n  width: 100%;\n  height: 100%;\n  padding-block: 0.75rem;\n  padding-left: 0.5rem; /* Add padding to the left to make room for the icon */\n  border: none;\n  outline: none;\n  color: var(--color-black-500);\n  background: transparent;\n}\n\n.search-submit {\n  display: none; /* Hide the button as we're using the icon inside the input */\n}\n\n/* Responsive Media Query */\n@media only screen and (min-width: 62rem) {\n  .search {\n    justify-self: center;\n    grid-column: initial;\n    order: initial;\n    width: 100%;\n    height: auto;\n  }\n\n  .search-form {\n    max-width: 30rem;\n  }\n}\n\n.menu {\n  position: fixed;\n  top: -100%;\n  left: 0;\n  width: 100%;\n  height: auto;\n  overflow: hidden;\n  padding-block: 3rem 2rem;\n  background: var(--color-white-100);\n  box-shadow: var(--shadow-medium);\n  transition: all 0.45s ease-in-out;\n}\n\n.menu.is-active {\n  top: 0;\n  width: 100%;\n  height: inherit;\n}\n\n.menu-inner {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  row-gap: 1.25rem;\n}\n\n.menu-link {\n  font-family: inherit;\n  font-size: 1rem;\n  font-weight: 500;\n  line-height: inherit;\n  text-transform: uppercase;\n  /* color: var(--color-black-500); */\n  color: white;\n  transition: all 0.35s ease-in-out;\n}\n\n.menu-link:hover {\n  outline: none;\n  color: var(--color-primary);\n}\n\n/* Responsive Media Query */\n@media only screen and (min-width: 36rem) {\n  .menu {\n    position: relative;\n    justify-self: end;\n    top: 0;\n    left: inherit;\n    width: auto;\n    height: auto;\n    padding-block: 0;\n    background: none;\n    box-shadow: none;\n    transition: none;\n  }\n\n  .menu-inner {\n    display: flex;\n    flex-direction: row;\n    column-gap: 1.25rem;\n    margin: 0 auto;\n  }\n\n  .menu-link {\n    text-transform: capitalize;\n  }\n}\n\n.burger {\n  position: relative;\n  justify-self: end;\n  cursor: pointer;\n  user-select: none;\n  z-index: 10;\n  width: 1.6rem;\n  height: 1.15rem;\n  border: none;\n  outline: none;\n  background: none;\n  visibility: visible;\n  transform: rotate(0deg);\n  transition: 0.35s ease;\n}\n\n/* Responsive Media Query */\n@media only screen and (min-width: 36rem) {\n  .burger {\n    display: none;\n    visibility: hidden;\n  }\n}\n\n.burger-line {\n  position: absolute;\n  width: 100%;\n  height: 2px;\n  border-radius: 1rem;\n  background: var(--color-black-500);\n  transition: all 0.35s ease;\n}\n\n.burger-line:nth-child(1) {\n  top: 0;\n}\n\n.burger-line:nth-child(2) {\n  top: 0.55rem;\n}\n\n.burger-line:nth-child(3) {\n  top: 1.1rem;\n}\n\n.burger.is-active .burger-line:nth-child(1) {\n  top: 0.55rem;\n  transform: rotate(135deg);\n}\n\n.burger.is-active .burger-line:nth-child(2) {\n  opacity: 0;\n  visibility: hidden;\n}\n\n.burger.is-active .burger-line:nth-child(3) {\n  top: 0.55rem;\n  transform: rotate(-135deg);\n}\n\n/* Scrollbar */\n::-webkit-scrollbar {\n  width: 0.5rem;\n}\n\n::-webkit-scrollbar-thumb {\n  background: var(--color-black-400);\n  border-radius: 0.25rem;\n}\n\n::-webkit-scrollbar-thumb:hover {\n  background: var(--color-black-200);\n}\n\n::-webkit-scrollbar-track {\n  background: var(--color-white-300);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
